import Reports from "../components/reports";

const ReportPage = () => {
  return <Reports />;
};

export default ReportPage;
